import http from 'conversations-http/clients/http';
export const fetchAdminUsers = () => {
  return http.get(`messages/v2/users/admin`);
};